/**
 * 共通スクリプトのエントリ
 * jQuery / Splide をここで読み込み、window に渡してから各モジュールを実行
 */
import $ from 'jquery';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';

window.$ = window.jQuery = $;
window.Splide = Splide;

import './scroll-restore.js';
import { initOverlayScrollbar } from './overlay-scrollbar.js';
import { init as smoothScrollInit } from './smoothScroll.js';
import { init as hamburgerInit } from './hamburger.js';
import { init as splideInit } from './splide.js';
import { init as topJobsInit } from './topJobs.js';
import { init as accordionInit } from './accordion.js';
import { init as footerNavInit } from './footerNav.js';
import { contactFormInit } from './contactForm.js';

function init() {
	initOverlayScrollbar();
	smoothScrollInit();
	hamburgerInit();
	splideInit();
	topJobsInit();
	accordionInit();
	footerNavInit();
	contactFormInit();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
